<div class="re-bg-white">

  @for (pricePart of prices; track pricePart; let first = $first; let indexOfPrice = $index) {
    <div>
      @if (!first) {
        <hr class="re-border-t-3 re--mx-20 re-border-monochrome-light md:re--mx-30">
      }
      <bdo-single-accordion
        [shortInfo]="'summary.tariff.priceExpand' | translate"
        [arrowRight]="true"
        [isOpenInitially]="first"
        [buttonStyles]="'re-px-20 md:re-px-30 re-pt-10 md:re-pt-15 re-pb-10 md:re-pb-15'"
        [attr.data-qa]="'tariffdetails' + indexOfPrice">
        <div slot="customHeader" class="re-inline-block re-justify-center re-text-justify re-mr-auto">
          <h5 class="bold re-inline-block re-mr-5">
            {{(hasPriceCap ? pricePart.priceCapYear.monthlyPrice : pricePart.firstYear.monthlyPrice) | currency: 'EUR'}}
          </h5>
          <div class="re-inline-block re-xs">{{ 'tariff.perMonth' | translate }}
            @if (prices.length > 1) {
              <span>{{first ? 'bis' : 'ab'}}
                <span class="bold">{{(first ? pricePart?.priceEndDate : pricePart?.priceStartDate) | date }}</span>
              </span>
            }
          </div>
        </div>
        <hr class="re-mb-15 re-border-t re-border-monochrome-medium-light">
        <div class="re-px-20 md:re-px-30">
          <!-- Consumption / Consumption HT -->
          <div class="re-tariff-row">
            <div class="re-relative re-pr-30">
              @if (hasMissingNtConsumptionForHTNT) {
                {{ 'tariff.overview.consumptionCalculated' | translate }}
              } @else {
                {{ 'tariff.overview.consumption' | translate }}
              }
              @if (isHTNT && tariffData.annualConsumption && tariffData.annualConsumptionNt) {
                <span>({{ 'meterreadings.tariffs.high' | translate }})</span>
              }
              @if (hasMissingNtConsumptionForHTNT) {
                <span>({{ 'meterreadings.tariffs.highAndLow' | translate }})
                  <bdo-inline-tooltip>
                    <span [innerHtml]="'tariff.overview.consumptionCalculatedHTNTHint' | translate"></span>
                  </bdo-inline-tooltip></span>
                }
              </div>
              <div>{{tariffData.annualConsumption| number}} {{tariffData?.division | divisionToUnit: "billing"}}</div>
            </div>
            <!-- Working price HT, if double tarif meter -->
            @if (isHTNT) {
              <bdo-tariff-prices-workingprice
                [price]="tariffAdvisorService?.getHTNTPrice('HT', isGewe, tariffData?.parts?.[indexOfPrice]?.contractSums)"
            [description]="(tariffData?.individualText?.show ? 'Red. ' : '') +
              ('general.tariff.workingPriceInUnit' | translate: { unit: tariffData?.division | divisionToUnit: 'billing'}) + ' (HT)'"
            [textInfoI]="('contract.details.costs.workingPriceHintHT' | translate) + ' ' +
                         ('contract.details.costs.workingPriceHint' | translate)"
              ></bdo-tariff-prices-workingprice>
            }
            <!-- Consumption NT -->
            @if (tariffData?.annualConsumptionNt) {
              <div class="re-tariff-row">
                <div class="re-relative re-pr-30">
                  {{ 'tariff.overview.consumption' | translate }} ({{ 'meterreadings.tariffs.low' | translate }})
                </div>
                <div>{{tariffData?.annualConsumptionNt | number}} {{tariffData?.division | divisionToUnit: "billing"}}</div>
              </div>
            }
            <!-- Working price NT, if double tarif meter -->
            @if (isHTNT) {
              <bdo-tariff-prices-workingprice
                [price]="tariffAdvisorService?.getHTNTPrice('NT', isGewe, tariffData?.parts?.[indexOfPrice]?.contractSums)"
                [description]="(tariffData?.individualText?.show ? 'Red. ' : '') + ('general.tariff.workingPriceInUnit' | translate: { unit: tariffData?.division | divisionToUnit: 'billing'}) + ' (NT)'"
            [textInfoI]="('contract.details.costs.workingPriceHintNT' | translate) + ' ' +
                         ('contract.details.costs.workingPriceHint' | translate)"
              ></bdo-tariff-prices-workingprice>
            }
            <!-- WorkingPrice -->
            @for (workingPrice of tariffData?.parts?.[indexOfPrice]?.contractSums; track workingPrice) {
              <div>
                @if (!isHTNT) {
                  <bdo-tariff-prices-workingprice
                    [price]="isGewe ? workingPrice?.workNet : workingPrice?.workGross"
                    [description]="(tariffData?.individualText?.show && !tariffData.dynamictariff ? 'Red. ' : '') + ('general.tariff.workingPriceInUnit' | translate: { unit: tariffData?.division | divisionToUnit: 'billing'})"
                    [textInfoI]="'contract.details.costs.workingPriceHint' | translate"
                  ></bdo-tariff-prices-workingprice>
                }
                @if (tariffData.dynamictariff) {
                  <bdo-tariff-prices-workingprice
                    [price]="isGewe ? workingPrice?.workNetDynamic : workingPrice?.workGrossDynamic"
                    [description]="('general.tariff.workingPriceDynamicInUnit' | translate)"
              [textInfoI]="('general.tariff.workingPriceDynamicInfo' | translate:
                { priceInCent: (workingPrice?.workGrossDynamic)})"
                  ></bdo-tariff-prices-workingprice>
                }
              </div>
            }
            <!-- BasePrice -->
            @for (option of tariffData?.parts?.[indexOfPrice]?.contractLevel; track option) {
              <div>
                @if (option.level === 1) {
                  <div>
                    <div class="re-tariff-row">
                      <div class="re-relative re-pr-30">
                        <span>{{tariffData?.individualText?.show && !tariffData.dynamictariff ? 'Red. ' : ''}} {{ 'contract.details.costs.yearlyBasePrice' | translate }}</span>
                        @if (infoWorkprice) {
                          <span class="re-absolute re-ml-10">
                            <bdo-inline-tooltip>
                              <span [innerHtml]="infoBaseprice"></span>
                            </bdo-inline-tooltip>
                          </span>
                        }
                      </div>
                      <div>+ {{(isGewe ? option.baseNet : option.baseGross) | currency: 'EUR'}}</div>
                    </div>
                  </div>
                }
                <!-- MeterPrice -->
                @if (option.level === 15) {
                  <div class="re-tariff-row">
                    <div class="re-relative re-pr-30">
                      <span>{{ 'contract.details.costs.meterPrice' | translate }}</span>
                      <span class="re-absolute re-ml-10">
                        <bdo-inline-tooltip>
                          <div [innerHTML]="meterTooltip"></div>
                        </bdo-inline-tooltip>
                      </span>
                    </div>
                    <div>+ {{(isGewe ? option.baseNet : option.baseGross) | currency: 'EUR'}}</div>
                  </div>
                }
                <!-- other options with basePrice -->
                @if (option.baseGross !== null && option.baseNet !== null && option.level !== 1 && option.level !== 15) {
                  <div class="re-tariff-row">
                    <div>{{ option?.description }}</div>
                    <div>
                      {{ (option.baseNet > 0) ? '+' : '' }}
                      {{(isGewe ? option.baseNet : option.baseGross) | currency: 'EUR'}}
                    </div>
                  </div>
                }
              </div>
            }
            <!-- Bonus -->
            @for (bonus of bonusToShow; track bonus) {
              @if (!bonus.description.includes(KEY_FOR_CHARGE_FLEX_BONUS)) {
                <div class="re-tariff-row">
                  <div class="re-relative re-pr-30">
                    <span class="re-text-success">{{ bonus?.bonusType }}</span>
                    <span class="re-absolute re-ml-10">
                      <bdo-inline-tooltip data-name="bonus-price-info">
                        <span [innerHtml]="bonus.bonusInfoI"></span>
                      </bdo-inline-tooltip>
                    </span>
                  </div>
                  <div class="re-text-success">{{(isGewe ? bonus.baseNet : bonus.baseGross) | currency: 'EUR'}}</div>
                </div>
              }
            }
            <!-- ChargeFlex Special Bonus -->
            @if (getChargeFlexBonusData(indexOfPrice)) {
              <hr class="re-my-15 re-border-t re-border-monochrome-medium-light">
              <div class="re-tariff-row">
                <div> {{ 'tmh.summary.yearlyCostWithoutBonus' | translate }} </div>
                <div class="bold">
                  {{pricePart?.secondYear?.annualPrice | currency: 'EUR'}}
                </div>
              </div>
              <div class="re-tariff-row bold">
                <div> {{ 'tmh.summary.monthlyCostWithoutBonus' | translate }} </div>
                <div class="bold re-text-sm md:re-text-m">
                  {{pricePart?.secondYear?.monthlyPrice | currency: 'EUR'}}
                </div>
              </div>
              <hr class="re-my-15 re-border-t re-border-monochrome-medium-light">
              <h5 class="re-mb-20">{{'tmh.summary.bonusHeadline' | translate}}</h5>
              <div class="re-tariff-row">
                <div>{{ 'tmh.summary.yearlyConsumption' | translate }}
                  @if (isContractEdit) {
                  <span class="re-absolute re-ml-10">
                    <bdo-inline-tooltip>
                      {{ 'tariff.selection.chargeFlexConsumptionInfo' | translate}}
                    </bdo-inline-tooltip>
                  </span>
                  }
                </div>
                <div>{{getChargeFlexBonusData(indexOfPrice)?.quantity | number}} kWh
                  <!-- {{getChargeFlexBonusData(indexOfPrice)?.quantityUnit}} -->
                </div>
              </div>
              <div class="re-tariff-row">
                <div>
                  {{ 'tmh.summary.flexCredit' | translate }}
                  <span class="re-absolute re-ml-10">
                    <bdo-inline-tooltip>
                      {{'tmh.summary.info.flexCredit' | translate}}
                    </bdo-inline-tooltip>
                  </span>
                </div>
                <div>× {{getChargeFlexBonusData(indexOfPrice)?.unitPriceGross * 100 | currency:'Cent'}}</div>
              </div>
              <div class="re-tariff-row re-text-green">
                <div>
                  {{ 'tmh.summary.bonus' | translate }}
                  <span class="re-absolute re-ml-10">
                    <bdo-inline-tooltip>
                      {{'tmh.summary.info.optimizeBonus' | translate}}
                    </bdo-inline-tooltip>
                  </span>
                </div>
                <div>{{getChargeFlexBonusData(indexOfPrice)?.baseGross | currency: 'EUR'}}</div>
              </div>
              <hr class="re-my-15 re-border-t re-border-monochrome-medium-light">
              <div class="re-tariff-row re-text-sm">
                <div> {{ 'tmh.summary.yearlyCostWithBonus' | translate }} </div>
                <div class="bold">
                  {{pricePart?.firstYear?.annualPrice | currency: 'EUR'}}
                </div>
              </div>
              <div class="re-tariff-row bold re-text-sm md:re-text-m re-pb-20">
                <div class="re-mb-10"> {{ 'tmh.summary.monthlyCostWithBonus' | translate }} </div>
                <div class="bold re-text-m md:re-text-l">
                  {{pricePart?.firstYear?.monthlyPrice | currency: 'EUR'}}
                </div>
              </div>
            }
            @if (!getChargeFlexBonusData(indexOfPrice)?.quantity) {
              <hr class="re-my-15 re-border-t re-border-monochrome-medium-light">
              @if (hasBonus) {
                <div class="re-tariff-row">
                  <div>
                    {{ 'contract.details.costs.annualPriceBonus' | translate }}
                    @if (hasMissingNtConsumptionForHTNT) {
                      <bdo-inline-tooltip>
                        <span [innerHtml]="'contract.details.costs.priceCaclulationInfo' | translate"></span>
                      </bdo-inline-tooltip>
                    }
                  </div>
                  <div class="bold">
                    {{pricePart?.firstYear?.annualPrice | currency: 'EUR'}}
                  </div>
                </div>
              } @else {
                <div class="re-tariff-row">
                  <div>
                    {{ (tariffData.dynamictariff ? 'contract.details.costs.annualPriceDynamic' : 'contract.details.costs.annualPrice' ) | translate }}
                    @if (hasMissingNtConsumptionForHTNT) {
                      <bdo-inline-tooltip>
                        <span [innerHtml]="'contract.details.costs.priceCaclulationInfo' | translate"></span>
                      </bdo-inline-tooltip>
                    }
                  </div>
                  <div class="bold">
                    {{pricePart?.firstYear?.annualPrice | currency: 'EUR'}}
                  </div>
                </div>
              }
              <div class="re-pb-15">
                <!-- Kosten pro Monat -->
                @if (hasBonus) {
                  <!-- headline cost per year -->
                  <div class="re-tariff-row re-mb-30">
                    <div class="bold" [ngClass]="{'h5': !hasPriceCap}">
                      {{ 'contract.details.costs.monthlyPriceBonus' | translate }}
                    </div>
                    <div class="bold re-mb-15" [ngClass]="{'h4': !hasPriceCap}">{{pricePart?.firstYear?.monthlyPrice | currency: 'EUR'}}</div>
                  </div>
                  <!-- yearly cost after first year -->
                  @if (pricePart?.secondYear) {
                    <div class="re-tariff-row">
                      <div class="re-relative re-pr-30">
                        <span>{{ 'contract.details.costs.annualPriceSecond' | translate }}</span>
                      </div>
                      <div>{{pricePart?.secondYear?.annualPrice | currency: 'EUR'}}</div>
                    </div>
                  }
                  <!-- monthly cost after first year -->
                  @if (pricePart?.secondYear) {
                    <div class="re-tariff-row re-mb-0" >
                      <div class="re-relative re-pr-30">
                        <span>{{ 'contract.details.costs.monthlyPriceSecond' | translate }}</span>
                      </div>
                      <div>{{pricePart?.secondYear?.monthlyPrice | currency: 'EUR'}}</div>
                    </div>
                  }
                } @else {
                  <div class="re-tariff-row re-mb-0">
                    <div class="bold" [ngClass]="{'h5': !hasPriceCap}">{{ (tariffData.dynamictariff ? 'contract.details.costs.monthlyPriceDynamic' : 'contract.details.costs.monthlyPrice') | translate }}</div>
                    <div class="bold" [ngClass]="{'h4': !hasPriceCap}">{{pricePart?.firstYear?.monthlyPrice | currency: 'EUR'}}</div>
                  </div>
                }
              </div>
            }
          </div>
          <!-- show price cap -->
          @if (tariffData?.parts?.[indexOfPrice]?.priceCap) {
            <hr class="re-border-t-3 re--mx-20 re-border-monochrome-light md:re--mx-30">
            <bdo-tariff-price-cap
              [tariffDataParts]="tariffData?.parts?.[indexOfPrice]"
              [isGewe]="isGewe"
              [division]="tariffData?.division"
              [infois]="tariffData?.infois"
            ></bdo-tariff-price-cap>
          }
        </bdo-single-accordion>
        @if (tariffData?.parts.length > 1 && first) {
          <hr class="re-border-t-3 re--mx-30 re-border-monochrome-light">
          <bdo-info-box [type]="'info'" [marginBottom]="false">
            <span class="re-hidden md:re-inline">{{ 'tariff.priceAdjustment.hint' | translate }}</span>
            <span class="md:re-hidden re-inline">{{ 'tariff.priceAdjustment.hintSmall' | translate }}</span>
          </bdo-info-box>
        }
      </div>
    }
  </div>
